/**
 * 此模块需要使用先使用: Fetch Util
 */
import DictionarySelect from './dictionary-select.vue'

/* istanbulistanbul ignore next */
DictionarySelect.install = function (Vue) {
  Vue.component(DictionarySelect.name, DictionarySelect)
}

export default DictionarySelect



// WEBPACK FOOTER //
// ./src/cdpBase/baseComponents/dictionarySelect/index.js